import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RegisterCustomer } from 'src/app/utils/models';
import { environment } from '../../../../environments/environment';

const headers = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

const headers2 = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Accept', 'application/json')
  .set('Access-Control-Allow-Origin', '*');

@Injectable()
export class PublicDataService {
  idioma: string;
  constructor(private readonly http: HttpClient) {
    this.idioma = 'esp';
  }

  generateVisitor(id: number) {
    const body = {
      idTarjeta: id,
    };
    return this.http.post<any>(
      environment.api_apisqa.concat('api/PanelPortada/VisitaTarjetaGuardar'),
      body,
      headers
    );
  }

  getCardData(alias: string, idioma: string): Observable<any> {
    const body = { alias, idioma };
    return this.http.post<any>(
      environment.api_qaapis.concat('api/Home/consultarDatosTarjeta'),
      body,
      headers
    );
  }

  getSocialNetworks(
    idTarjeta: number,
    idUsuario: number,
    idioma: string
  ): Observable<any> {
    const body = { idTarjeta, idUsuario, idioma };
    return this.http.post<any>(
      environment.api_apisqa.concat('api/Informacion/redesSocialesConsultar'),
      body,
      headers
    );
  }

  createMessage(
    nombre: string,
    correo: string,
    telefono: string,
    mensajeEnviar: string,
    idUsuario: number,
    idioma: string
  ): Observable<any> {
    const body = { nombre, correo, telefono, mensajeEnviar, idUsuario, idioma };
    return this.http.post<any>(
      environment.api_apisqa.concat('api/Informacion/mensajeGuardar'),
      body,
      headers
    );
  }

  getUserServices(
    idTarjeta: number,
    idUsuario: number,
    idioma: string
  ): Observable<any> {
    const body = { idTarjeta, idUsuario, idioma };
    return this.http.post<any>(
      environment.api_qaapis.concat(
        'api/PanelServicios/consultarServiciosTarjeta'
      ),
      body,
      headers
    );
  }

  getUserGallery(
    idTarjeta: number,
    idUsuario: number,
    idioma: string
  ): Observable<any> {
    const body = { idTarjeta, idUsuario, idioma };
    return this.http.post<any>(
      environment.api_apisqa.concat('api/Servicios/serviciosFotos'),
      body,
      headers
    );
  }

  getFirstAccess(
    userName: string,
    pwd: string,
    idioma: string
  ): Observable<any> {
    const body = { userName, pwd, idioma };
    return this.http.post<any>(
      environment.api_apisqa.concat('api/Home/validarUsuario'),
      body,
      headers
    );
  }

  // getSecondAccess(
  //   correo: string,
  //   pwd: string,
  //   idioma: string
  // ): Observable<any> {
  //   const body = { idSitio: Site.siteId, correo, pwd, idioma };
  //   return this.http.post<any>(
  //     environment.api_pasarela.concat('api/Clientes/Validar'),
  //     body,
  //     headers
  //   );
  // }
 
  getUserData(idUsuario: number, idioma: string): Observable<any> {
    const body = { idUsuarioValor: idUsuario, idUsuario, idioma };
    console.log(body);
    return this.http.post<any>(
      environment.api_apisqa.concat('api/PanelPortada/datosUsuario'),
      body,
      headers
    );
  }

  getUserCover(idUsuario: number, idioma: string): Observable<any> {
    const body = { idTarjeta: 0, idUsuario, idioma };
    return this.http.post<any>(
      environment.api_qaapis.concat('api/PanelPortada/consultarTarjetaPortada'),
      body,
      headers
    );
  }

  getUserPermissions(idUsuario: number): Observable<any> {
    return this.http.get<any>(
      environment.dashboard + `usuarios/permisos/${idUsuario}`
    );
  }

  createRecoveryPassword(Username: string): Observable<any> {
    return this.http.post<any>(
      environment.api_apisqa.concat('api/Home/recuperaPassword'),
      Username,
      headers
    );
  }

  createUser(body: any): Observable<any> {
    const formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));
    return this.http.post<any>(
      environment.api_apisqa.concat('api/Home/continuarV2'),
      formData
    );
  }

  createCustomer(body: RegisterCustomer): Observable<any> {
    return this.http.post<any>(
      environment.api_pasarela.concat('api/Clientes/registrarCliente'),
      body,
      { headers: headers2 }
    );
  }

  getCountry(idUsuario: number, idioma: string): Observable<any> {
    const body = { idUsuario, idioma };
    return this.http.post<any>(
      environment.api_apisqa.concat('api/Home/comboPais'),
      body,
      headers
    );
  }

  createCoverPage(body: any): Observable<any> {
    const formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));
    return this.http.post<any>(
      environment.api_qaapis.concat('api/PanelPortada/tarjetaPortadaGuardar'),
      formData
    );
  }

  getUserPlan(idUsuario: number, idioma: string): Observable<any> {
    const body = { idUsuario, idioma };
    return this.http.post<any>(
      environment.api_apisqa.concat('api/Profile/consultarPlanes'),
      body,
      headers
    );
  }

  deleteCompany(body: any): Observable<any> {
    return this.http.post<any>(
      environment.api_apisqa.concat('api/PanelPortada/TarjetaEliminarEmpresa'),
      body,
      headers
    );
  }

  // updateTarjeta(idTarjeta: number, body: any): Observable<any> {
  //   return this.http.patch<any>(
  //     environment.dashboard.concat(`tarjetas/${idTarjeta}`),
  //     body,
  //     headers
  //   );
  // }

  updateTarjeta(body: any): Observable<any> {
    return this.http.patch<any>(
      environment.dashboardT.concat(`api/panelsobremi/guardarProfesion`),
      body,
      headers
    );
  }

  getDefaultLanguage(aliasOrId: string | number) {
    return this.http.get(
      environment.dashboard + `usuarios/idioma/${aliasOrId}`
    );
  }

  updateDefaultLanguage(idUsuario: number, language: 'es' | 'en') {
    const body = { idioma: language };
    return this.http.patch(
      `${environment.dashboard}usuarios/${idUsuario}`,
      body,
      headers
    );
  }

  addClient(body: any): Observable<any> {
    return this.http.post<any>(
      environment.api_apisqa.concat('api/PanelPortada/ClientePopUpGuardar'),
      body,
      headers
    );
  }


  getPopupConfiguration(idTarjeta: number, idUsuario: number, idioma: string): Observable<any> {
    return this.http.get(
      environment.api_qaapis + `api/PanelPortada/ConsultarConfiguracionPopUp/?IdTarjeta=${idTarjeta}&IdUsuario=${idUsuario}&Idioma=${idioma}`
    );
  }
  
  guardarConfiguracionPopUp(body: any): Observable<any> {
    const formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));
    return this.http.post<any>(
      environment.api_qaapis.concat('api/PanelPortada/ConfiguracionPopUpGuardar'),
      formData
    );
  }

  guardarRespuestaPopUp(body: any): Observable<any> {
    return this.http.post<any>(
      environment.api_apisqa.concat('api/PanelPortada/RespuestaPopUpGuardar'),
      body,
      headers
    );
  }

  getPopupTarjeta(idTarjeta: number, idUsuario: number, idioma: string): Observable<any> {
    return this.http.get(
      environment.api_qaapis + `api/PanelPortada/ConsultarPopUpTarjeta/?IdTarjeta=${idTarjeta}&IdUsuario=${idUsuario}&Idioma=${idioma}`
    );
  }

  eliminarRespuesta(idRespuesta: number, idUsuario: number, idioma: string): Observable<any> {
    return this.http.delete(
      environment.api_apisqa + `api/PanelPortada/EliminarRespuestaPopUpGuardar/?IdRespuesta=${idRespuesta}&IdUsuario=${idUsuario}&Idioma=${idioma}`
    );
  }
}
